import { Heading as NativeBaseHeading } from 'native-base';
import React from 'react';
import { Platform } from 'react-native';

import type {
  HeadingProps,
  HeadingColors,
  HeadingSizes,
} from './Heading.types';

const colors: HeadingColors = {
  default: 'gray.900',
  secondary: 'gray.600',
  disabled: 'gray.500',
  link: 'blue.500',
  error: 'red.500',
  warning: 'orange.700',
  success: 'green.500',
  white: 'white',
};

const headingSizes: HeadingSizes = {
  'title-1': {
    size: '4xl',
  },
  'title-2': {
    size: '3xl',
  },
  'heading-1': {
    accessibilityLevel: 1,
    size: '2xl',
  },
  'heading-2': {
    accessibilityLevel: 2,
    size: 'xl',
  },
  'heading-3': {
    accessibilityLevel: 3,
    size: 'lg',
  },
  'heading-4': {
    accessibilityLevel: 4,
    size: 'md',
  },
  'heading-5': {
    accessibilityLevel: 5,
    size: 'sm',
  },
  'heading-6': {
    accessibilityLevel: 6,
    size: 'xs',
  },
};

export const Heading: React.FunctionComponent<HeadingProps> = ({
  accessibilityLevel,
  color = 'default',
  size = 'heading-3',
  ...props
}) => {
  const headingSize = headingSizes[size];

  return (
    <NativeBaseHeading
      accessibilityLevel={accessibilityLevel ?? headingSize.accessibilityLevel}
      // @ts-ignore react-native-web
      accessibilityRole={Platform.OS === 'web' ? 'heading' : 'header'}
      color={colors[color]}
      size={headingSize.size}
      {...props}
    />
  );
};
